/**
 * @flow
 * @relayHash 58f156fd61920537ead867634ff8200e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type GLNormalBalance = "CREDIT" | "DEBIT";
export type UpdateGLAccountInput = {|
  id: string,
  accountNumber?: ?string,
  name?: ?string,
  description?: ?string,
  accountType?: ?GLAccountType,
  subType?: ?string,
  normalBalance?: ?GLNormalBalance,
  parentAccountId?: ?string,
  isActive?: ?boolean,
|};
export type UpdateGLAccountMutationVariables = {|
  input: UpdateGLAccountInput
|};
export type UpdateGLAccountMutationResponse = {|
  +updateGLAccount: {|
    +glAccountEdge: {|
      +node: {|
        +id: string,
        +accountNumber: string,
        +name: string,
        +description: ?string,
        +accountType: GLAccountType,
        +normalBalance: GLNormalBalance,
        +balance: number,
        +isActive: boolean,
        +isSystem: boolean,
        +parentAccount: ?{|
          +id: string,
          +name: string,
        |},
      |}
    |}
  |}
|};
export type UpdateGLAccountMutation = {|
  variables: UpdateGLAccountMutationVariables,
  response: UpdateGLAccountMutationResponse,
|};
*/


/*
mutation UpdateGLAccountMutation(
  $input: UpdateGLAccountInput!
) {
  updateGLAccount(input: $input) {
    glAccountEdge {
      node {
        id
        accountNumber
        name
        description
        accountType
        normalBalance
        balance
        isActive
        isSystem
        parentAccount {
          id
          name
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateGLAccountInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateGLAccount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGLAccountPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "glAccountEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccountEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "normalBalance",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "balance",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isActive",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isSystem",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "parentAccount",
                "storageKey": null,
                "args": null,
                "concreteType": "GLAccount",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateGLAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateGLAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateGLAccountMutation",
    "id": null,
    "text": "mutation UpdateGLAccountMutation(\n  $input: UpdateGLAccountInput!\n) {\n  updateGLAccount(input: $input) {\n    glAccountEdge {\n      node {\n        id\n        accountNumber\n        name\n        description\n        accountType\n        normalBalance\n        balance\n        isActive\n        isSystem\n        parentAccount {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '78db3dd96c2a8b3272317146e15c9130';
module.exports = node;
